export default __webpack_public_path__ + "static/media/ic_matic_16.710c0aa1.svg";